import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import NavigationsGridLayout from './containers/Grid';

export default function NavigationLayout() {
  return <Router>
    <PrivateRoute path="/cms/settings/navigations" component={NavigationsGridLayout} />
  </Router>;
}
